export default {
  请输入邮箱smtp: 'Please enter the email smtp',
  修改: 'modify',
  退出登录: 'Log out and log in',
  状态: 'state',
  修改成功: 'Modified successfully',
  清空数据: 'wipe data ',
  强退: 'Forceful retreat',
  收起: 'Put it away',
  登录地点: 'Login location',
  保存: 'preserve',
  '可以省略，省略后默认为邮箱账号smtp.邮箱后缀,例如：邮箱账号为：zbtech@163.com，smtp为smtp.163.com':
    'It can be omitted. If omitted, it defaults to the email account smtp. Email suffix, for example: Email account is: zbtech@163.com SMTP is SMTP.163.3com',
  用户昵称: 'User nickname',
  清空: 'empty',
  请求参数: 'Request parameters',
  通知: 'notice',
  操作信息: 'Operation information',
  此操作将会清空所有调度日志数据项: 'This operation will clear all scheduling log data items',
  邮箱账号不能为空: 'Email account cannot be empty',
  添加字典类型: 'Add Dictionary Type',
  邮件密匙ID: 'Email Key ID',
  失败: 'fail',
  邮件AccessKeyId: 'Email AccessionKeyId',
  操作: 'operation',
  系统模块: 'System modules',
  登录信息: 'login information',
  请输入内容: 'Please enter the content',
  否: 'no',
  发送邮箱账号: 'Send email account',
  其他: 'other',
  是: 'yes',
  审核失败: 'Review failed',
  '列展开/排序': 'Column expansion/sorting',
  富文本: 'Rich Text',
  登录时间: 'login time',
  男: 'male',
  腾讯云: 'Tencent Cloud',
  访问编号: 'Access number',
  请求地址: 'Request address',
  审核状态: 'Review status',
  展开: 'launch',
  刷新成功: 'Refresh successful',
  操作日期: 'Operation date',
  参数类型: 'Parameter type',
  腾讯邮件: 'Tencent Email',
  邮箱密码不能为空: 'Email password cannot be empty',
  切为全屏: 'Switch to full screen',
  当前选中编号为: 'The current selected number is',
  发送邮箱smtp: 'Send email SMTP',
  的数据: 'Data for',
  操作人员: 'Operators',
  删除: 'delete',
  刷新缓存: 'Refresh cache',
  重置: 'Reset',
  公告: 'announcement',
  主机: 'main engine',
  昵称: 'nickname',
  请输入账号: 'Please enter your account number',
  参数主键: 'Parameter primary key',
  此操作将会清空所有操作日志数据项: 'This operation will clear all operation log data items',
  密钥SECRET: 'Key SECRET',
  此操作将导出当前条件下所有数据而非选中数据:
    'This operation will export all data under the current conditions instead of the selected data',
  条: 'strip',
  此操作将会清空所有登录日志数据项: 'This operation will clear all login log data entries',
  审核失败原因: 'Reason for audit failure',
  注销时间: 'Cancellation time',
  参数名称: 'Parameter Name',
  用户名称: 'User Name',
  解锁: 'Unlock',
  新增成功: 'New successfully added',
  操作状态: 'Operation status',
  共: 'common',
  输入框: 'Input box',
  女: 'female',
  文本域: 'Text Field',
  导出: 'export',
  请输入: 'Please enter ',
  取消: 'cancel',
  不能为空: 'Cannot be empty',
  日志编号: 'Log number',
  系统内置: 'Built in system',
  当前选中字典编号为: 'The currently selected dictionary number is',
  个人设置: 'Personal settings',
  阿里云: 'Alibaba Cloud',
  注销原因: 'Reason for cancellation',
  邮件RegionId: 'Email RegionId',
  成功: 'success',
  浏览器: 'browser',
  字典名称: 'Dictionary Name',
  登录地址: 'Login address',
  审核人: 'Reviewer',
  发送邮箱密码: 'Send email password',
  登录状态: 'Login status',
  添加参数: 'Add parameters',
  待审核: 'Pending review',
  审核时间: 'Review time',
  查询: 'query',
  联系电话: 'Contact phone number',
  修改字典类型: 'Modify Dictionary Type',
  '是否确认清空?': 'Are you sure to clear it?',
  接口信息: 'Interface information',
  参数键值: 'Parameter key values',
  请求方式: 'Request method',
  操作方法: 'Operation method',
  字典编号: 'Dictionary number',
  生日: 'birthday',
  参数键名: 'Parameter key name',
  详细: 'detailed',
  本地邮件: 'Local Mail',
  阿里邮件: 'Alibaba Mail',
  授权: 'authorization',
  生成代码: 'Generate Code',
  操作系统: 'operating system',
  审核成功: 'Review successful',
  使用状态: 'Usage status',
  个人中心: 'Personal Center',
  禁用: 'Disabled',
  备注: 'Remarks',
  操作模块: 'Operation module',
  邮箱: 'mailbox',
  启用: 'Enable',
  操作类型: 'Operation type',
  区域ID: 'Region ID',
  新增: 'New addition',
  导入: 'Import',
  邮件AccessKeySecret: 'Email AccessiKeySecret',
  修改参数: 'modify parameters',
  '是否确认导出?': 'Are you sure to export?',
  查看更多: 'View more',
  列排序需拖动名称: 'Column sorting requires dragging the name',
  性别: 'Gender',
  字典类型: 'Dictionary type',
  请输入密码: 'Please enter password',
  创建时间: 'Creation time',
  '确认删除所选中数据?': 'Are you sure to delete the selected data?',
  操作地点: 'Operation location',
  清空成功: 'Clear successfully',
  删除成功: 'Delete successful',
  提示: 'prompt',
  '确定注销并退出系统吗？': 'Are you sure to log out and exit the system?',
  确定: 'confirm',
  密码登录: 'Password login',
  普朗思后台管理系统: 'T-poweress backend management system',
  退出全屏: 'Exit Full Screen',
  '全选/不选': 'Select All/Not Select',
  '点击选择显示数据项，调整数据项顺序': 'Click to select display data items and adjust the order of data items',
  数据写入: 'Data writing',
  设备标识: 'Equipment identification',
  参数: 'parameter',
  写入值: 'Write value',
  请选择: 'Please select ',

  手机号码: 'Mobile phone number',
  添加用户: 'Add user',
  取消批量授权: 'Cancel bulk authorization',
  返回: 'Back',
  取消授权: 'Cancel authorization',
  手机: 'mobile phone',
  '确认要取消该用户的角色吗?': 'Are you sure you want to cancel the role of this user?',
  当前选中用户: 'Currently selected user',
  取消授权成功: 'Cancel authorization successful',
  '是否取消选中用户授权数据项?': 'Do you want to uncheck the user authorization data item?',
  角色名: 'Role Name',
  权限字符: 'Permission Characters',
  确认: 'Confirm',
  停用: 'Deactivate',
  '的角色吗?': ' is it a character?',
  更多: 'more',
  脱敏权限: 'Desensitization permission',
  数据权限: 'Data permissions',
  分配用户: 'Assign Users',
  角色编号: 'Role Number',
  权限标识: 'Permission identification',
  排序: 'sort',
  确认要: 'Confirm to',
  角色吗: 'Role?',
  关闭: 'close',
  异常: 'abnormal',
  角色名称: 'Role Name',
  角色标识: 'Role identification',
  权限范围: 'Scope of permissions',
  '展开/折叠': 'Expand/Fold',
  '全选/全不选': 'Select All/Select None',
  父子联动: 'Father son linkage',
  全部数据权限: 'All data permissions',
  自定义数据权限: 'Custom data permissions',
  本部门数据权限: 'Data permissions for this department',
  本部门及以下数据权限: 'Data permissions for this department and below',
  仅本人数据权限: 'Only personal data permissions',
  分配数据权限: 'Assign data permissions',
  '超级管理员角色信息 不可更改': 'Super administrator role information cannot be changed',
  菜单权限: 'Menu permissions',
  顺序: 'order',
  添加角色: 'Add Role',
  修改角色: 'Modify Role',
  列名: 'Column names',
  列名描述: 'Column Name Description',
  是否脱敏: 'Is it desensitized',
  脱敏方向: 'Desensitization direction',
  从右向左: 'From right to left',
  从左向右: 'From left to right',
  起始位置: 'Starting position',
  脱敏字符数: 'Desensitized characters',
  设置脱敏权限: 'Set desensitization permissions',
  '操作成功！': 'Operation successful!',
  选择用户: 'Select Users',
  手机号: 'Mobile phone number',
  请选择状态: 'Please select a status',
  项目: 'project',
  用户编号: 'User ID',
  用户名: 'user name',
  重置密码: 'reset password',
  分配角色: 'Assign Roles',
  '的用户吗?': 'Is it a user of?',
  密码: 'password',
  岗位: 'post',
  角色: 'role',
  '用户密码长度必须介于 5 和 20 之间': 'User password length must be between 5 and 20',
  请正确填写邮箱地址: 'Please fill in your email address correctly',
  请正确填写手机号: 'Please fill in your phone number correctly',
  修改用户: 'Modify Users',
  新增用户: 'New Users',
  请输入搜索内容: 'Please enter search content',
  新密码: 'New password',
  确认密码: 'Confirm password',
  '请输入5-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种':
    'Please enter 5-20 English letters, numbers, or symbols (excluding spaces), and at least two types of letters, numbers, and punctuation marks are required',
  请再次输入新密码确认: 'Please enter the new password again to confirm',
  两次输入的密码不一致: 'The passwords entered twice are inconsistent',
  重置成功: 'Reset successful',
  菜单名称: 'Menu Name',
  DIY页面: 'DIY page',
  图标: 'icon',
  组件路径: 'Component path',
  上级菜单: 'Superior menu',
  菜单类型: 'Menu Type',
  目录: 'catalogue',
  菜单: 'menu',
  DIY菜单: 'DIY menu',
  按钮: 'button',
  选择图标: 'Select icon',
  是否外链: 'Is it an external link',
  '选择是外链则路由地址需要以`http(s)://`开头':
    'If selecting an external link, the routing address needs to start with `http (s)://`',
  路由地址: 'Routing address',
  是否显示: 'Is it displayed',
  '选择隐藏则路由将不会出现在侧边栏，但仍然可以访问':
    'If you choose to hide, the route will not appear in the sidebar, but it can still be accessed',
  '选择停用则路由将不会出现在侧边栏，也不能被访问':
    'If you choose to disable, the route will not appear in the sidebar and cannot be accessed',
  是否缓存: 'Is it cached',
  缓存: 'cache',
  不缓存: 'Do not cache',
  添加菜单: 'add menu',
  修改菜单: 'Modify menu',
  // 这里是新增
  部件名称: 'Component Name',
  状态: 'state',
  差值: 'Difference',
  设备地址: 'Equipment address',
  不等于: 'Not equal to',
  BOM维护: 'BOM maintenance',
  菜单管理: 'Menu management',
  获取验证码: 'Obtain verification code',
  告警设备: 'Alarm device',
  最后登录IP: 'Last login IP',
  域名信息: 'Domain information',
  所属模板: 'Template to which it belongs',
  描述: 'describe',
  设备分配: 'Equipment allocation',
  当前密码强度: 'Current password strength',
  与: 'With',
  已分配: 'Assigned',
  用户动态: 'User dynamics',
  用户昵称: 'User nickname',
  用户管理: 'User management ',
  已处理工单: 'Processed W/O',
  控制规则: 'Control rules',
  验证码登录: 'Verification code login',
  或: 'or',
  SMTP主机地址: 'SMTP host address',
  登录账号: 'Login Account',
  用户名: 'user name',
  '数据删除后无法恢复，请确认': 'Data cannot be recovered after deletion, please confirm',
  确定要禁用该用户吗: 'Are you sure you want to disable this user',
  科创能采集控制通用平台: 'Sci Tech Innovation Energy Collection and Control Universal Platform',
  操作: 'operation',
  处理人: 'Processing personnel',
  否: 'no',
  请选择: 'Please choose',
  工单来源: 'W/O source',
  是: 'yes',
  登录: 'Sign in',
  报警记录: 'Alarm record',
  设备状态: 'Equipment status',
  暂无数据: 'No data available at the moment',
  值: 'value',
  配件类型: 'Accessory type',
  处理图片: 'Processing images',
  正常状态: 'Normal state',
  科创能采集控制: 'Science and technology innovation can collect and control data',
  文件: 'file',
  手机: 'mobile phone',
  处理人姓名: 'Name of processor',
  部件型号: 'Component model',
  升级: 'upgrade',
  请输入正确的手机号或邮箱: 'Please enter the correct phone number or email address',
  通讯协议: 'Communication Protocol',
  模板名称: 'Template Name',
  大于: 'greater than',
  数据设置: 'Data settings',
  删除: 'delete',
  确定要删除该用户吗: 'Are you sure you want to delete this user?',
  离线状态: 'Offline status',
  ' 设备状态': 'Equipment status',
  设备位置: 'Equipment location',
  离线数: 'Offline Number',
  小于: 'less than',
  待处理工单: 'Pending W/O',
  告警: 'give an alarm',
  昵称: 'nickname',
  存储时长: 'Storage duration',
  请输入昵称: 'Please enter a nickname',
  告警规则: 'Alarm rules',
  数据导出: 'Data export',
  更换时间: 'Change time',
  邮箱不能为空: 'Email cannot be empty',
  告警组名称: 'Alarm group name',
  等于: 'be equal to',
  在线设备: 'Online devices',
  离线: 'off-line',
  安全设置: 'Security setting',
  信息概览: 'Information Overview',
  系统管理: 'System Management',
  是否接收告警邮件: 'Whether to receive alert emails',
  最后登录时间: 'Last login time',
  请输入: 'Please enter',
  取消: 'cancel',
  设备上报: 'Equipment reporting',
  忘记密码: 'Forgot password',
  厂家: 'manufactor',
  最小值: 'minimum value',
  证书信息: 'Certificate Information',
  请输入地址查询: 'Please enter the address for inquiry',
  规则阈值条件: 'Rule threshold conditions',
  设备编号: 'Equipment number',
  文本: 'text',
  s后重新获取: 'Retrieve after s',
  设备详情: 'device details ',
  条数据: 'Article data',
  SMTP配置: 'SMTP configuration',
  已取消: 'Cancelled',
  '请阅读并同意《用户注册协议》与《隐私协议》':
    'Please read and agree to the User Registration Agreement and Privacy Agreement',
  查询: 'query',
  设备编码: 'Equipment code',
  系统消息: 'System message',
  活动消息: 'Activity message',
  设备名称: 'Equipment name',
  单位: 'Company',
  采集控制平台: 'Collection and Control Platform',
  历史记录: 'Historical records',
  在线: 'on-line',
  请正确填写邮箱地址: 'Please fill in the email address correctly',
  设备模板: 'Equipment Template',
  确认密码: 'Confirm password',
  旧密码: 'Old password',
  分组名称: 'Group name',
  '1个月报警数': 'Number of alarms in one month',
  工单列表: 'W/O List',
  已阅读并同意: 'I have read and agree',
  在线数量: 'Online quantity',
  图片附件: 'Image attachment',
  时间: 'time',
  电子邮件: 'E-mail',
  '20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种':
    '20 English letters, numbers, or symbols (excluding spaces), with at least two types of letters, numbers, and punctuation included',
  请再次输入新密码确认: 'Please enter the new password again to confirm',
  待处理: 'Pending processing',
  证书管理: 'Certificate Management',
  全部设备: 'All devices',
  选择配件分组: 'Select accessory grouping',
  数值: 'numerical value',
  图标: 'Icon',
  请输入旧密码: 'Please enter old password',
  规则名称: 'Rule Name',
  备注: 'remarks',
  属性类型: 'Attribute type',
  系统工具: 'System Tools',
  密码不能为空: 'Password cannot be empty',
  邮箱: 'mailbox',
  属性标识符: 'Attribute identifier',
  证书: 'certificate',
  提交: 'Submit',
  data设置: 'Data settings',
  已升级: 'Upgraded',
  风机信息: 'Fan info',
  端口: 'port',
  点击选择显示列: 'Click to select display column',
  配件总数: 'Total number of accessories',
  规则设置: 'Rule Setting',
  工单设备: 'W/O equipment',
  请正确填写手机号: 'Please fill in your phone number correctly',
  导入: 'Import',
  新增: 'newly added',
  确定: 'determine',
  最近上线时间: 'Latest online time',
  告警历史: 'Alarm History ',
  在线数: 'Online Number',
  性别: 'Gender',
  基本设置: 'Basic Settings',
  密码: 'password',
  角色: 'role',
  BOM名称: 'BOM Name',
  手机号: 'cell-phone number',
  确认: 'confirm',
  模式配置: 'Mode configuration',
  设备对应属性编码: 'Equipment corresponding attribute code',
  升级管理: 'Update Management',
  请输入手机号或邮箱: 'Please enter your phone number or email address',
  修改: 'modify',
  登录日志: 'Login log',
  退出登录: 'Log out and log in',
  配件列表: 'Accessories List',
  修改成功: 'Modified successfully',
  请填写手机号: 'Please provide your phone number',
  出厂时间: 'Factory time',
  保存: 'preservation',
  设备云端共享: 'Cloud based device sharing',
  历史数据: 'Historical data ',
  设备: 'equipment',
  报警内容: 'Alarm content',
  数据大屏: 'Big Data Screen',
  两次输入的密码不一致: 'The passwords entered twice are inconsistent',
  设备中心: 'Device Center',
  新密码: 'New password',
  '6个月报警数': 'Number of alarms in 6 months',
  设备列表: 'Device List',
  配件Key: 'Accessories Key',
  SMTP主机: 'SMTP Host ',
  帮助文档: 'Help document',
  阈值: 'threshold',
  PWM: 'PWM',
  存储设定: 'Storage settings',
  账户密码: 'Account password',
  版本号: 'Version number',
  已分组配件: 'Grouped accessories',
  SMTP端口号: 'SMTP port number',
  基本信息: 'essential information',
  驾驶舱: 'Control Center',
  离线设备: 'off-line equipment',
  下发: 'Issued',
  报警时间: 'Alarm time',
  排序: 'sort',
  编辑: 'edit',
  规则数: 'Number of rules',
  男: 'male',
  正常: 'normal',
  强: 'strong',
  列表: 'list',
  用户列表: 'User List',
  未分配: 'Unallocated',
  配件告警组: 'Accessory alarm group',
  序号: 'Serial number',
  已处理报警: 'Alarm processed',
  请输入验证码: 'Please enter the verification code',
  数据类型: 'data type',
  工单说明: 'W/O Description',
  重置: 'Reset',
  数据位号: 'Data Tag Number',
  运行时间: 'Running time',
  刷新页面: 'Refresh page',
  配件: 'parts',
  模板总数: 'Total number of templates',
  证书数量: 'Number of certificates',
  处理人联系方式: 'Contact information of the processor',
  条: 'strip',
  代码生成: 'code generation',
  工单管理: 'W/O Management',
  提示: 'Tips',
  在线状态: 'Online status',
  配件数: 'Number of accessories',
  报警: 'call the police',
  设备导入: 'Equipment import',
  指定范围: 'Specify the scope',
  公网: 'Public network',
  女: 'female',
  隐私协议: 'Privacy Agreement',
  导出: 'export',
  用户注册协议: 'User Registration Agreement',
  所属证书: 'Belonging certificate',
  待处理报警异常: 'Pending alarm exception',
  报警值: 'Alarm value',
  最大值: 'Maximum value',
  最后上报时间: 'Final reporting time',
  属性备注: 'Attribute Remarks',
  最近离线时间: 'Recent offline time',
  手机号不能为空: 'The phone number cannot be empty',
  请输入帐户名: 'Please enter the account name',
  请输入新密码: 'Please enter a new password',
  账号: 'account number',
  联系人: 'contacts',
  所含配件: 'Accessories included',
  保密: 'secrecy',
  本地: 'local',
  处理: 'handle',
  未分组配件: 'Ungrouped accessories',
  详情: 'details',
  升级状态: 'Upgrade status',
  更换次数: 'Number of replacements',
  请填写手机号邮箱: 'Please provide your phone number and email address',
  通讯类型: 'Communication type',
  '当前账号无菜单权限，请联系管理员':
    'The current account does not have menu permissions. Please contact the administrator',
  系统接口: 'system interface ',
  小数位数: 'Decimal places',
  返回: 'return',
  问题描述: 'Problem description',
  设备数据单位: 'Equipment data unit',
  当前有: 'Currently available',
  选择未分组配件: 'Select ungrouped accessories',
  已处理: 'Processed',
  确定注销并退出系统吗: 'Are you sure to log out and exit the system',
  '是否取消该订单,请确认': 'Do you want to cancel this order? Please confirm',
  清除缓存: 'Clear cache',
  未分组: 'Not grouped',
  处理说明: 'Processing instructions',
  设备信息: 'Equipment information',
  云端下发: 'Cloud based distribution',
  切换全屏: 'Switch to full screen',
  风机名称: 'Fan name',
  报警数: 'Number of alarms',
  风机模板: 'Fan template',
  证书名称: 'Certificate Name',
  主机地址: 'Host address',
  配件名称: 'Accessory Name',
  条件: 'condition',
  更新记录: 'Update Record',
  属性名称: 'Attribute Name',
  文件上传: 'File upload',
  周期: 'cycle',
  设备总数: 'Total number of devices',
  批次: 'batch',
  port号: 'Port number',
  禁用: 'Disable',
  查看: 'see',
  重置密码: 'reset password ',
  服务器地址: 'server address',
  上级用户: 'Superior user',
  属性展示名称: 'Attribute Display Name',
  固件列表: 'Firmware List',
  退出全屏: 'Exit Full Screen',
  工作台: 'Workbench',
  设备协议: 'Device Protocol',
  告警数: 'Number of alarms',
  设备类型: 'Equipment type',
  看板: 'bulletin board',
  请确认密码: 'Please confirm password',
  报警状态: 'Alarm status',
  版本名称: 'Version Name',
  枚举: 'enumeration',
  今日报警数: 'Todays number of alarms',
  联系方式: 'contact information',
  配件详情: 'Accessories Details',
  工单状态: 'W/O status',
  标识符: 'identifier ',
  所属配件: 'Belonging accessories',
  最后上传时间: 'Last upload time',
  列表详情: 'List Details',
  数据: 'data',
  待升级: 'To be upgraded',
  云端私有: 'Cloud Private',
  加载更多: 'Load more',
  处理备注: 'Processing remarks',
  登录密码: 'Login password',
  请输入密码: 'Please input a password',
  创建时间: 'Creation time',
  角色管理: 'Role management',
  风机型号: 'Fan model',
  我的资源: 'My Resources',
  密码登录: 'Password login',
  欢迎来到: 'Welcome to',
  我的工单: 'My W/O',
  采集控制通用平台: 'Collection and Control Universal Platform',
  请完成安全验证: 'Please complete security verification',
  向右滑动完成验证: 'Swipe right to complete verification',
  成功: 'success',
  创建成功: 'Created successfully',
  编辑成功: 'Edited successfully',
  保存成功: 'Saved successfully',
  验证成功: 'Verification successful',
  验证失败: 'Verification failed',
  您确定要导出所选证书数据信息吗: 'Are you sure you want to export the selected certificate data information',
  处理时间: 'processing time',
  处理内容: 'processing content',
  选择设备: 'Select device',
  选择导出时间: 'Select export time',
  下发证书: 'Issuing certificates',
  是否取消该订单: 'Do you want to cancel this order',
  请确认: 'Please confirm',
  确定要: 'Are you sure',
  该用户吗: 'this user',
  数据配置: 'Data configuration',
  管理工作台: 'Management Workbench',
  数据工作台: 'Data Workbench',
  我的设备: 'My device',
  配件分组: 'Accessory group',
  图库管理: 'Library Management',
  证书列表: 'Certificate List',
  我的证书: 'My certificate',
  所属用户: 'Belonging users',
  工单动态: 'Work Order Dynamics',
  配置设备列表显示项: 'Configure device list display items',
  类型名称: 'Type name',
  '建议最多导出7天，超过7天数据导出响应较慢':
    'Suggest exporting for a maximum of 7 days, as exporting data after 7 days may result in slower response times',
  '选择导出时间（建议最多导出7天，超过7天数据导出响应较慢）':
    'Select export time (Suggest exporting for a maximum of 7 days, as exporting data after 7 days may result in slower response times)',
  首次报警时间: 'First alarm time',
  最新报警时间: 'Latest alarm time',
  已导出: 'Exported',
  未导出: 'Not exported',
  故障图标: 'Fault icon',
  '规则名称（英文）': 'Rule Name (English)',
  风机: 'fan',
  '属性名称（英文）': 'Attribute Name (English)',
  计算方式: 'Calculation method',
  保留小数位: 'Keep decimal places',
  编辑设备类型: 'Edit device type',
  主图: 'Host graph',
  数组: 'array',
  设置数组项: 'Set array items',
  显示: 'display',
  设置枚举项: 'Set enumeration items',
  '位数(从0开始)': 'Number of digits (starting from 0)',
  字段名称: 'Field name',
  枚举值: 'enumerated value',
  枚举描述: 'enumeration description',
  运行参数设置: 'Run parameter settings',
  远程遥控: 'Remote control',
  '1个月': '1 month',
  '2个月': '2 month',
  '3个月': '3 month',
  '4个月': '4 month',
  '5个月': '5 month',
  '6个月': '6 month',
  '7个月': '7 month',
  '8个月': '8 month',
  '9个月': '9 month',
  '10个月': '10 month',
  '11个月': '11 month',
  '12个月': '12 month',
  '上传中...': 'Uploading...',
  基础数据上传: 'Upload basic data',
  '请刷新页面后重新选择文件！': 'Please refresh the page and select the file again!',
  // 菜单名称
  设备分析: 'Device Analysis',
  财务分析: 'Financial Analysis',
  用户分析: 'User Analysis',
  场站分析: 'Station Analysis',
  客户: 'Customer',
  运营商: 'Operator',
  平台用户: 'Platform User',
  场地管理: 'Site Management',
  场地列表: 'Site List',
  场地审核: 'Site Approval',
  场地标签: 'Site Label',
  设备管理: 'Device Management',
  统计中心: 'Statistics Center',
  电站统计: 'Power Station Statistics',
  电桩统计: 'Plug Statistics',
  运营商统计: 'Operator Statistics',
  财务管理: 'Financial Management',
  营收概况: 'Revenue Overview',
  财务明细: 'Financial Details',
  订单列表: 'Order List',
  提现审核: 'Withdrawal Approval',
  提现记录: 'Withdrawal Record',
  充值中心: 'Recharge Center',
  发票管理: 'Invoice Management',
  分润记录: 'Profit Sharing Record',
  占用记录: 'Occupancy Record',
  用户流水: 'User Flow',
  运营中心: 'Operation Center',
  优惠券: 'Coupon',
  优惠券发放: 'Coupon Issuance',
  收费模板: 'Fee Template',
  广告: 'Advertisement',
  招商中心: 'Marketing Center',
  协议语言: 'Agreement Language',
  用户协议: 'User Agreement',
  常见问题: 'Frequently Asked Questions',
  平台客服: 'Platform Customer Service',
  资讯: 'Information',
  消息通知: 'Message Notification',
  问题类型: 'Problem Type',
  广告类型: 'Advertisement Type',
  车辆品牌: 'Vehicle Brand',
  运维工单: 'Maintenance Work Order',
  故障报修: 'Fault Repair',
  意见反馈: 'Feedback',
  反馈类型: 'Feedback Type',
  初始化配置: 'Initial Configuration',
  设备品牌: 'Device Brand',
  设备型号: 'Device Model',
  '正在刷新页面！': 'Refreshing the page!',
  通知消息: 'Notification message',
  账号ID: 'Account ID',
  修改头像: 'Modify Avatar',
  选择图片: 'Select image',
  当前浏览器不支持全屏: 'The current browser does not support full screen',
}
